import "./components/pds-copy/index.css";
import "./i18n/config";
import "./index.scss";
import { configureDayjs } from "./utils/configureDayjs";
import "@politiet/sheriff-web-components";
import "@politiet/sheriff-css-framework";
import { initI18n } from "./i18n/config";
import { logFrontendToBackend } from "./feil/logFrontendToBackend";

initI18n();


void import(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  "https://www.politiet.no/core/webcomponents/pno-core-webcomponents.js?v=1"
).catch((e: unknown) => {
  if (e instanceof  Error) {
    logFrontendToBackend(e)
  }
});

//Sett denne til false for å bruke header og footer fra politiet.no lokalt
export const mockPnoCore =
  import.meta.env.VITE_MOCK_PNO_CORE == "true" && import.meta.env.DEV;

configureDayjs();
